import { createWithEqualityFn } from 'zustand/traditional';

import { School, UserPreferences } from '@common-types';

import { baseService } from '@services/base.service';
import useAuthStore from '@store/AuthStore';

export interface UserInfo {
  userId: number;
  phone: string;
  email: string;
  notifyTenantAvailable: boolean;
}

export interface UserInfoStore {
  userInfo: UserInfo;
  userPreferences: UserPreferences;
  nearbySchools: School[];
  setUserInfo: (userData: UserInfo) => Promise<void>;
  setUserPreferences: (userPreferences: UserPreferences) => void;
  setNearbySchools: (nearbySchools: School[]) => void;
  setSchoolSharingNotificationRead: () => void;
  getPostalCode: () => string | undefined;
}

const initialState = {
  userInfo: {} as UserInfo,
} as UserInfoStore;

export const useUserInfoStore = createWithEqualityFn<UserInfoStore>()(
  (set) => ({
    ...initialState,

    getPostalCode: () => {
      let postalCode;

      const addresses = useAuthStore.getState().authSession.userData?.profile?.addresses;
      const primaryAddress = addresses?.filter((address) => {
        return address.isPrimary;
      });

      if (primaryAddress && primaryAddress.length > 0) {
        postalCode = primaryAddress[0].postCode;
      } else if (addresses && addresses.length > 0) {
        postalCode = addresses[0].postCode;
      }

      return postalCode;
    },

    setUserInfo: async (userInfo: UserInfo) => {
      const userData: Partial<UserInfoStore> = { userInfo };

      userData.nearbySchools = await baseService.getAsync<School[]>(
        '/nearby?classesOffered=4&carnegieSizeSettings=2-year,4-year&institutionTypes=Public,Private (non-profit)',
      );

      set({
        ...userData,
      });
    },

    setSchoolSharingNotificationRead: () => {
      void baseService.patchAsync(`/user/preferences`, {
        notifyWhenTenantAssigned: false,
      });
    },

    setUserPreferences: (userPreferences: UserPreferences) => {
      set({
        userPreferences,
      });
    },
  }),
  Object.is,
);
